<script setup>
const user = useUser()
const ui = useUi()
const { getFlashMessageKey } = useHelpers()

const email = ref('')
const isChoosePasswordModalOpen = ref(false)

function openChoosePasswordModal (withEmail) {
  ui.flashMessageKey = getFlashMessageKey()
  email.value = withEmail
  isChoosePasswordModalOpen.value = true
}

function closeChoosePasswordModal () {
  isChoosePasswordModalOpen.value = false
}

function handleSuccess () {
  closeChoosePasswordModal()
}
</script>

<template>
  <div
    class="mt-32 w-full py-12 md:mt-40"
    style="background: linear-gradient(90deg, rgba(66, 85, 255, 0.20) 0%, rgba(0, 163, 255, 0.20) 100%)">
    <AppContainer>
      <div
        class="mx-auto flex w-full max-w-xl flex-col items-center gap-8 md:gap-10 xl:h-18 xl:max-w-full xl:flex-row xl:gap-20"
        :class="user.isGuest ? 'justify-between' : 'justify-center md:text-center'">
        <p class="heading-primary shrink-0 text-3xl font-bold md:text-[40px] md:leading-tight xl:text-2xl">
          {{ user.isGuest ? 'Join up' : 'You are subscribed' }} to get updates on <em>Developer Certifications</em>
        </p>
        <LandingSignUpForm
          v-if="user.isGuest"
          @success="openChoosePasswordModal" />
      </div>
    </AppContainer>
  </div>

  <AuthChoosePasswordModal
    v-bind="{ isOpen: isChoosePasswordModalOpen, email }"
    @success="handleSuccess"
    @close="closeChoosePasswordModal" />
</template>
